export default function autoSchoolLevel({ state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  if (!state.container.schoolLevels?.length) {
    return null;
  }

  return state.container.schoolLevels[0];
}
